// Single source of truth for Microsoft Entra (Azure AD) identifiers used by MSAL.
// Values come from the active Angular environment file (swapped per build config:
// dev -> environment.development.ts, test -> environment.staging.ts) so each
// deployed environment authenticates against its OWN app registration. The
// hardcoded fallbacks preserve the previous behaviour if a field is missing.
import { environment } from '../../environments/environment';

/** Entra tenant. Must match staticwebapp.config.json (openIdIssuer). */
export const AAD_TENANT_ID = environment.aadTenantId || 'fd799da1-bfc1-4234-a91c-72b3a1cb9e26';

/** App registration (client) ID for the SPA + API (per environment). */
export const AAD_CLIENT_ID = environment.aadClientId || '3d1c9ccc-0d53-4cf5-be50-a57a01269245';

/**
 * API scope exposed by this SAME app registration. The SPA requests an access
 * token for this scope; the Function App validates it. Configure the scope with
 * scripts/setup-entra-app-registration.ps1 (Expose an API → access_as_user).
 * When the app reg uses a custom-domain identifier URI (e.g. api://nest-ui-dev.chevron.com)
 * rather than the GUID form, set AAD_API_SCOPE in the pipeline so set-env.js writes it here.
 */
export const API_SCOPE: string = (environment as any).apiScope || `api://${AAD_CLIENT_ID}/access_as_user`;

/** Scopes requested at login so the API-scope consent is captured up front. */
export const LOGIN_SCOPES = ['openid', 'profile', 'email', API_SCOPE];
